import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class TranslationService extends BaseService {

    static url = "translations";
    static apis = {
        getAll: { path: this.url, method: "get" },
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("translations");
    }

    getTranslations(language_code,table='%00',foreign_ids='%00') {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: TranslationService.apis.getAll.path+'/'+language_code+"?table="+table+"&foreign_ids="+foreign_ids,
                    method: TranslationService.apis.getAll.method,
                    authorization: false,
                    showLoader:false,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

}

export default TranslationService;